import DescriptionList from './DescriptionList'
import sortBy from 'lodash/sortBy'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class MetaTagList extends Component {
  static propTypes = {
    metaTags: PropTypes.array.isRequired
  }

  formatMetaTags() {
    const { metaTags } = this.props
    let ancestryPaths = metaTags.map(metaTag => metaTag.ancestryPath)
    ancestryPaths = sortBy(ancestryPaths, ancestryPath =>
      ancestryPath[0].toLowerCase()
    )

    return ancestryPaths.reduce((memo, ancestryPath) => {
      memo[ancestryPath[0]] = memo[ancestryPath[0]] || []
      memo[ancestryPath[0]].push(ancestryPath[1])
      return memo
    }, {})
  }

  render() {
    return <DescriptionList listItems={this.formatMetaTags()} />
  }
}



// WEBPACK FOOTER //
// ../src/components/MetaTagList.js